import { useEffect, useState } from "react";
import PageMarkup from "../../common/PageMarkup";
import { getOwnerDetails, getShopDetails } from "../../redux/actions/shop";
import MessagingTools from "./MessagingTools";
import AbandonedCart from './AbandonedCart/AbandonedCart';
import OrderCrm from './OrderCrm/OrderCrm';
import Settings from './Settings/Settings';
import ExtensionTemplates from "./ExtensionTemplates/Templates";
import { useLocation } from "react-router-dom";

const Messaging = () => {
    const shop = JSON.parse(localStorage.getItem('shop') || '{}');
    const [isEnabled, setIsEnabled] = useState(false);
    const [ownerDetails, setownerDetails] = useState();
    const location: any = useLocation();
    const [selectedTab, setSelectedTab] = useState(0);

    const fetchOwnerDetails = (shopId: string) => {
        getOwnerDetails(shopId).then(
        (response: any) => {
            if (response.status === 'success') {
            setownerDetails(response.owner);
            }
        },
        (err) => {}
        );
    };
  
    const fetchShopDetails = () => {
        getShopDetails().then(async (response: any) => {
        if (response.status === 'success') {
            if (response.shop.featuresList.includes('EXTENSION')) {
            setIsEnabled(true);
            }
        } else {
            setIsEnabled(false);
        }
        });
    };
  
    useEffect(()=>{
        fetchShopDetails();
        fetchOwnerDetails(shop.id);
        if(location?.state?.sourceTab){
          setSelectedTab(2);
        }
        else if(location?.state?.tab === 'home'){
          setSelectedTab(0);
          window.scrollTo({top: 0, behavior: 'smooth'});
        }
    },[]);

    const tabsDisabled = [
        {
          id: 'Messaging Tools',
          content: 'Messaging Tools',
          accessibilityLabel: 'Messaging Tools',
          panelID: 'messagingTools',
        },
        {
          id: 'Message Templates',
          content: 'Message Templates',
          accessibilityLabel: 'Message Templates',
          panelID: 'messageTemplates',
        }
      ];
    
      const tabContentDisabled = {
        0: <MessagingTools></MessagingTools>,
        1: <ExtensionTemplates></ExtensionTemplates>,
      };

      const tabs = [
        {
          id: 'Abandoned Cart',
          content: 'Abandoned Cart',
          accessibilityLabel: 'Abandoned Cart',
          panelID: 'abandonedCart',
        },
        {
          id: 'Order CRM',
          content: 'Order CRM',
          accessibilityLabel: 'Order CRM',
          panelID: 'OrderCrm',
        },
        {
          id: 'Message Templates',
          content: 'Message Templates',
          accessibilityLabel: 'Message Templates',
          panelID: 'messageTemplates',
        },
        {
          id: 'settings',
          content: 'Settings',
          accessibilityLabel: 'Settings',
          panelID: 'settings',
        },
      ];
    
      const tabContent = {
        0: <AbandonedCart owner={ownerDetails} />,
        1: <OrderCrm owner={ownerDetails} />,
        2: <ExtensionTemplates mode={location?.state?.sourceTab ? location.state.sourceTab : null}></ExtensionTemplates>,
        3: <Settings />,
      };

    return (
        <PageMarkup
            title='Messaging'
            tabs={isEnabled? tabs : tabsDisabled}
            tabContent={isEnabled? tabContent : tabContentDisabled}
            clean={true}
            messaging={isEnabled}
            selected={selectedTab}
        ></PageMarkup>
    );
}

export default Messaging;